export const NotificationTypes = {
    JobRequestCreated: 'JobRequestCreated',
    JobCreated: 'JobCreated',
    TimesheetRejected: 'TimesheetRejected',
    TimesheetOverEstimate: 'TimesheetOverEstimate',
    EmployeeCallOff: 'EmployeeCallOff',
};

